module.exports = __webpack_public_path__ + "media/images/admin/icons/user-x-c99f2431dc4ad2f8952fd27b313cab84.svg";